<template>
  <div
    :class="[fixed?'van-nav-bar--fixed':'']"
    :style="{'z-index':zIndex}"
  >
    <ld-statusbar :bg-white="transparent == false" />
    <van-nav-bar
      class="ld-header"
      :class="[
        transparent ? 'transparent' : '',
        white ? 'white' : ''
      ]"
      :left-text="leftText && !isGat()"
      :right-text="rightText"
      :title="title"
      :left-arrow="leftArrow && !isGat()"
      :border="border"
      :z-index="zIndex"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :safe-area-inset-top="isH5()"
    >
      <slot
        name="left"
        slot="left"
        v-if="!isGat()"
      />
      <slot
        name="title"
        slot="title"
      >
        <slot />
      </slot>
      <slot
        name="right"
        slot="right"
      />
    </van-nav-bar>
  </div>
</template>

<script>
import { NavBar } from 'vant'
import ldStatusbar from 'Common/ldStatusbar'
import { isH5 } from 'CommonUtils/plus'
import { isGat } from 'Utils/gattools'
import {isXlminp} from '../../../business/utils/xltools'

export default {
  name: 'LdHeader',
  components: {
    [NavBar.name]: NavBar,
    ldStatusbar
  },
  props: {
    leftText: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    fixed: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 1
    },
    leftArrow: {
      type: Boolean,
      default: true
    },
    white: Boolean,
    transparent: Boolean
  },
  data(){
    return {
    }
  },
  created(){

  },
  methods: {
    isH5,
    isGat,
    onClickLeft () {
      this.$emit('click-lefti')
      if (this.$listeners['click-left']) {
        this.$emit('click-left')
      } else if (this.$slots['left']) {
      } else {
        this.$router.go(-1)
      }
    },
    onClickRight () {
      this.$emit('click-right')
    }
  },
}
</script>

<style lang="less">

.ld-header.transparent {
  background-color: transparent;
}
.van-nav-bar__title {
  font-weight: bold;
}
.ld-header.white {
  .van-nav-bar__title, .van-icon {
    color: white;
  }
}

.ld-header .van-nav-bar__right {
  top: 8px;
}
</style>
